/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const currencyCodeMin = 3;
export const currencyCodeMax = 3;

export const currencyCodeRegExp = new RegExp("^[A-Z]{3}$");

export const Currency = zod
  .object({
    code: zod.string().min(currencyCodeMin).max(currencyCodeMax).regex(currencyCodeRegExp),
  })
  .describe("ISO 4217 currency.");

export type Currency = zod.input<typeof Currency>;
export type CurrencyOutput = zod.output<typeof Currency>;
